// extracted by mini-css-extract-plugin
export default {"form":"FormSchedule_form__DloAG","formBody":"FormSchedule_formBody__lpScL","buttonDelete":"FormSchedule_buttonDelete__QwoCR","timezone":"FormSchedule_timezone__pwbK6"};